<div class="d-flex">
  <div>
    <i>Tijdstip registratie: {{ printDate() }}</i>
  </div>
  <div class="flexer-3">
    <i>Geregistreerd door: {{ printUser() }}</i>
  </div>
</div>
